export default __webpack_public_path__ + "static/media/icon_edit_pink.d446fefc.svg";